import request from '@/utils/request'
// 地址
export function addressList() {
    return request({
        url: 'api/address/lists',
        method: 'get'
    })
}
export function addAddress(data) {
    return request({
        url: 'api/address/add',
        method: 'post',
        data
    })
}
export function updateAddress(data) {
    return request({
        url: 'api/address/update',
        method: 'post',
        data
    })
}
export function delAddress(id) {
    return request({
        url: 'api/address/delete',
        method: 'post',
        data: { id }
    })
}

export function defaultAddress() {
    return request({
        url: 'api/address/defaultAddress',
        method: 'get'
    })
}
export function isCheck(data) {
    return request({
        url: 'api/address/isCheck',
        method: 'post',
        data
    })
}
// 订单
export function ordersList(params) {
    return request({
        url: 'api/goods/ordersList',
        method: 'get',
        params
    })
}
export function orderDetail(id) {
    return request({
        url: 'api/goods/orderDetail',
        method: 'get',
        params: { id }
    })
}

export function teamOrderList(params) {
    return request({
        url: 'api/goods/teamOrderList',
        method: 'get',
        params
    })
}
export function cancel(data) {
    return request({
        url: 'api/goods/cancel',
        method: 'post',
        data
    })
}

export function submit(data) {
    return request({
        url: 'api/goods/submit',
        method: 'post',
        data
    })
}
export function relationOrder(id) {
    return request({
        url: 'api/goods/relationOrder',
        method: 'get',
        params: { id }
    })
}
export function orderVoucher(data) {
    return request({
        url: 'api/goods/orderVoucher',
        method: 'post',
        data
    })
}
export function confirm(data) {
    return request({
        url: 'api/goods/confirm',
        method: 'post',
        data
    })
}
// 个人中心
export function userInfo() {
    return request({
        url: 'api/usercenter/userInfo',
        method: 'get'
    })
}

export function myAward() {
    return request({
        url: 'api/usercenter/myAward',
        method: 'get'
    })
}

export function updatePayInfo(data) {
    return request({
        url: 'api/usercenter/updatePayInfo',
        method: 'post',
        data
    })
}
// 提现
export function userdrawRecord(params) {
    return request({
        url: 'api/usercenter/drawRecord',
        method: 'get',
        params
    })
}
export function drawRecord(params) {
    return request({
        url: 'api/bill/billList',
        method: 'get',
        params
    })
}
export function transferCommit(data) {
    return request({
        url: 'api/transfer/transferCommit',
        method: 'post',
        data
    })
}
export function tconfigTransferList(params) {
    return request({
        url: 'api/transfer/configTransferList',
        method: 'get',
        params
    })
}
export function drawConfig() {
    return request({
        url: 'api/usercenter/drawConfig',
        method: 'get'
    })
}

export function draw(data) {
    return request({
        url: 'api/usercenter/draw',
        method: 'post',
        data
    })
}
// 图片上传
export function fileUpload(data) {
    return request({
        url: 'api/upload/fileUpload',
        method: 'post',
        data
    })
}
// 留言
export function inboxList(params) {
    return request({
        url: 'api/usercenter/inboxList',
        method: 'get',
        params
    })
}
export function outboxList(params) {
    return request({
        url: 'api/usercenter/outboxList',
        method: 'get',
        params
    })
}
export function outbox(data) {
    return request({
        url: 'api/usercenter/outbox',
        method: 'post',
        data
    })
}
// 修改用户信息
export function editUserInfo(data) {
    return request({
        url: 'api/usercenter/editUserInfo',
        method: 'post',
        data
    })
}
export function updatePayPassword(data) {
    return request({
        url: 'api/usercenter/forgetPayPassword',
        method: 'post',
        data
    })
}

export function updateLoginPassword(data) {
    return request({
        url: 'api/usercenter/updateLoginPassword',
        method: 'post',
        data
    })
}

// 订单数量
export function ordersNums() {
    return request({
        url: 'api/goods/ordersNums',
        method: 'get'
    })
}

//充值
export function configRemit() {
    return request({
        url: 'api/remittance/configRemittanceList',
        method: 'get'
    })
}

export function remittanceCommit(data) {
    return request({
        url: 'api/remittance/remittanceCommit',
        method: 'post',
        data
    })
}

export function remittanceRecordList() {
    return request({
        url: 'api/remittance/remittanceRecordList',
        method: 'get'
    })
}
export function gathering() {
    return request({
        url: 'api/remittance/gathering',
        method: 'get',
    })
}

// 积分
export function userAccount() {
    return request({
        url: 'api/usercenter/userAccount',
        method: 'get',
    })
}

export function transferRecordList(params) {
    return request({
        url: 'api/transfer/transferRecordList',
        method: 'get',
        params
    })
}


export function billRecord() {
    return request({
        url: 'api/bill/billRecord',
        method: 'get'
    })
}
export function billRecordList(params) {
    return request({
        url: 'api/bill/billRecordList',
        method: 'get',
        params
    })
}
export function trialList() {
    return request({
        url: '/api/goods/trialList',
        method: 'get'
    })
}

export function trialOrder(data) {
    return request({
        url: 'api/goods/trialOrder',
        method: 'post',
        data
    })
}

export function saleOrderList() {
    return request({
        url: 'api/goods/saleOrderList',
        method: 'get'
    })
}

export function todayBillRecord() {
    return request({
        url: 'api/bill/todayBillRecord',
        method: 'get'
    })
}

export function rankList() {
    return request({
        url: 'api/rank/rankList',
        method: 'get'
    })
}

export function apply(rank_id) {
    return request({
        url: 'api/rank/apply',
        method: 'post',
        data: { rank_id }
    })
}

export function rankRecord() {
    return request({
        url: 'api/rank/rankRecord',
        method: 'get'
    })
}

export function submitNoPass(id) {
    return request({
        url: 'api/goods/submitNoPass',
        method: 'post',
        data: { id }
    })
}

export function confirmOrder() {
    return request({
        url: 'api/goods/confirmOrder',
        method: 'get'
    })
}